@use "~components/LegacyCard/tokens" as Card;

@mixin office-detail {
  list-style-type: none;
  line-height: 125%;
}

.container {
  @include Card.border;
  background-color: var(--white);
}

.office {
  padding: 16px;
  border-bottom: 1px solid var(--blue-01-at-30);
}

.officeDetails {
  margin: 0;
  padding: 0;
}

.officeName {
  @include office-detail;
  font-weight: var(--semibold-weight);
}

.officeDetail {
  @include office-detail;
}

.children {
  display: flex;
  flex-flow: column;
  padding: 0 24px;
}

.children > * {
  padding: 24px 0;
  border-bottom: 1px solid var(--blue-01-at-30);

  &:last-child {
    border: none;
  }
}
